import { useApis } from "@app/data/apis.ts";
import {
    ChangePasswordPost,
    ConfirmEMailPost,
    NewPasswordPost,
    RequestResetPasswordPost,
    ResetPasswordPost,
} from "@app/data/engine.ts";
import { handleApiError } from "@app/helpers/error-helper.tsx";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

export default function useUserData() {
    const apis = useApis();
    const changePasswordMutation = useMutation({
        mutationFn: (post: ChangePasswordPost) => apis.engine.user.userChangePasswordCreate(post),
        onSuccess: () => {
            toast.success("Password changed");
        },
        onError: (error: Error) => handleApiError(error, "Failed to change password"),
    });

    const confirmEmailMutation = useMutation({
        mutationFn: ({ userId, post }: { userId: string; post: ConfirmEMailPost }) =>
            apis.engine.user.userConfirmEmailCreate(userId, post),
        onSuccess: () => {
            toast.success("Email confirmed");
        },
        onError: (error: Error) => handleApiError(error, "Failed to confirm email"),
    });

    const adminChangePasswordMutation = useMutation({
        mutationFn: (post: NewPasswordPost) => apis.engine.user.userAdminChangePasswordCreate(post),
        onSuccess: () => toast.success("Password changed"),
        onError: (error: Error) => handleApiError(error, "Failed to change password"),
    });

    const requestPasswordResetMutation = useMutation({
        mutationFn: (post: RequestResetPasswordPost) => apis.engine.resetPassword.resetPasswordRequestCreate(post),
        onSuccess: () => {
            toast.success("Password reset request sent");
        },
        onError: (error: Error) => handleApiError(error, "Failed to send password reset request"),
    });

    const resetPasswordMutation = useMutation({
        mutationFn: (post: ResetPasswordPost) => apis.engine.resetPassword.resetPasswordCreate(post),
        onSuccess: () => {
            toast.success("Password reset");
        },
        onError: (error: Error) => handleApiError(error, "Failed to reset password"),
    });

    return {
        changePassword: changePasswordMutation,
        confirmEmail: confirmEmailMutation,
        adminChangePassword: adminChangePasswordMutation,
        requestPasswordReset: requestPasswordResetMutation,
        resetPassword: resetPasswordMutation,
    };
}
